import { useMemo } from 'react';

const useStocks = (stocks) => {
  /**
   * Recover the quantity available or with a delay of 12 to 24 hours
   * @type {object}
   */
  const getStocks = useMemo(
    () => ({
      available:
        stocks?.filter((stock) => stock.delay === 0 && stock.quantity > 0)[0]
          ?.quantity || 0,
      delayed:
        stocks
          ?.filter(
            (stock) =>
              stock.delay > 0 && stock.delay <= 24 && stock.quantity > 0,
          )
          .reduce((acc, curr) => acc + curr.quantity, 0) || 0,
      notAvailable:
        stocks?.filter((stock) => stock.delay > 24 && stock.quantity > 0)[0]
          ?.quantity || 0,
    }),
    [stocks],
  );

  const getTotalStock = () =>
    (stocks || []).reduce((acc, stock) => acc + stock.quantity, 0) || 0;

  return { getStocks, getTotalStock };
};

export default useStocks;
